module.exports = __webpack_public_path__ + "img/rich.c277ccb5.png";